import { Card, CardContent } from '../ui/card';
import { ExternalLink } from 'lucide-react';
import kentImage from '@/assets/kent-pickleball.png';
import julieImage from '@/assets/julie-coach.png';
import nileshImage from '@/assets/nilesh-coach.png';

const coaches = [
  {
    name: "Kent H. Frazier",
    role: "Co-Founder & CEO, ParadoxEdge",
    bio: "PPR Certified Coach with 30+ years in entrepreneurship and leadership development. A lifetime athlete in tennis, golf, soccer, and endurance sports (Ironman France finisher), Kent brings athletic wisdom to performance coaching.",
    clients: "AWS • Petco • BioMed Realty • Ghirardelli",
    linkedin: "https://www.linkedin.com/in/kent-frazier",
    image: kentImage
  },
  {
    name: "Julie Kessler",
    role: "Pro Player & Coach",
    bio: "Professional competitor at 5.0+ level with 12 years playing. Former Division I volleyball player. US Open Naples 2025 Bronze, US Master's World Cup Team 2024. Specializes in movement, balance, and mental resilience.",
    clients: null,
    linkedin: "https://www.linkedin.com/in/julie-kessler-a562a510/",
    image: julieImage
  },
  {
    name: "Nilesh Parikh",
    role: "Founder & CEO, Abundance Labs",
    bio: "Guides executives through transformational journeys addressing key growth levers. Specializes in lasting, embodied change through neurophysiological rewiring under pressure.",
    clients: "Disney • Accenture • National Geographic",
    linkedin: "https://www.linkedin.com/in/nileshparikh/",
    image: nileshImage
  }
];

const PickleballCoaches = () => {
  return (
    <section className="bg-card">
      <div className="container-mobile section-spacing max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-primary font-semibold tracking-[0.15em] uppercase text-sm mb-2">
            Your Guides
          </p>
          <h2 className="text-foreground">Meet the Coaches</h2>
        </div>

        <div className="space-y-8">
          {coaches.map((coach, i) => (
            <Card key={i} className="bg-background border border-border overflow-hidden hover:border-primary/40 transition-all duration-300">
              <CardContent className="p-6 md:p-8">
                <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center md:items-start">
                  <div className="w-36 h-36 md:w-44 md:h-44 flex-shrink-0 rounded-2xl overflow-hidden bg-muted">
                    <img
                      src={coach.image}
                      alt={`${coach.name} headshot`}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 text-center md:text-left">
                    <h3 className="text-foreground font-display text-xl md:text-2xl mb-1">{coach.name}</h3>
                    <p className="text-primary text-sm font-medium mb-3">{coach.role}</p>
                    <p className="text-muted-foreground text-sm leading-relaxed mb-4">{coach.bio}</p>
                    {coach.clients && (
                      <p className="text-foreground/40 text-xs font-semibold tracking-wide uppercase mb-4">
                        {coach.clients}
                      </p>
                    )}
                    <a
                      href={coach.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary text-sm font-medium hover:underline inline-flex items-center gap-1"
                    >
                      LinkedIn <ExternalLink className="h-3 w-3" />
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PickleballCoaches;
